module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_6.2c0d800a.svg";